import { Component } from '@angular/core';

import { HisAuthService } from 'hisng';
import { ResearchInfrastructureModuleOptions } from '../../research-infrastructure-module.options';

@Component( {
    templateUrl: './research-infrastructure-search-form.component.html'
} )
export class ResearchInfrastructureSearchFormComponent {

    public readonly moduleOptions = ResearchInfrastructureModuleOptions;

    constructor( public auth: HisAuthService ) { }
}
